import { Col, Row } from "antd";
import React from "react";
import { Loading } from "../../../../component/loading";
import lodash from "lodash";
import IncomeStaffWaitingTable from "./component/income_staff_waiting_table";

const IncomeStaffWaiting = (props) => {
  // -------------------------- VAR --------------------------
  const { loading, jobs, userList, setOpenInput, setRecord, userId } = props;
  const jobList = jobs?.filter((job) => {
    const totalIncome = lodash.sumBy(job?.staffs, (staff) => staff?.value);
    return job?.status !== "0" && totalIncome < job?.subtotal;
  });
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderWaitingList = () => {
    if (loading) {
      return (
        <Col span={24} align="center">
          <Loading />
        </Col>
      );
    } else {
      return (
        <IncomeStaffWaitingTable
          jobList={jobList}
          userList={userList}
          setOpenInput={setOpenInput}
          setRecord={setRecord}
          userId={userId}
        />
      );
    }
  };

  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Row gutter={[20, 20]}>
        <Col span={24}>{renderWaitingList()}</Col>
      </Row>
    </Col>
  );
};
export default IncomeStaffWaiting;
